// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3z0ti","errorLogs":"EditorFooter_errorLogs__2qyIO"};